// extracted by mini-css-extract-plugin
export default {"version-button-container":"v1Tez6sAtEm5rAsCjo8G","versionButtonContainer":"v1Tez6sAtEm5rAsCjo8G","version-button":"HAoeostW1USWORSx7I0Q","versionButton":"HAoeostW1USWORSx7I0Q"};